import MotionodePipeline from '../images/motionode/pipeline-flow.png'
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className='heroWrapper' >
      
      <div className='containerFull'>

        <div className='sliderWrapper'>
          <div className='heroSlide heroSlide-1'>
            <div className='heroTextWrapper'>
              <h2>Ship software changes faster <br /><span className='text-pink-orange'>without losing production control</span>.</h2>
              <p>We help teams maintain and modernize existing software with AI-assisted engineering, human review, and controlled delivery powered by Motionode.</p>
              <div className='hero-cta-group'>
                <Link to={`/contact-us`} className='baseButton midnightkBttn'>
                  <span>Book a Backlog Review</span>
                </Link>
                <a href="#motionode" className='hero-secondary-link'>See how we work</a>
              </div>
            </div>
            <div className='heroImageWrapper'> 
              <div className='heroImage'>
                <img src={ MotionodePipeline } alt="Motionode delivery pipeline" loading="lazy"/>
              </div>
            </div>
          </div>
        </div>

        <div className='bgCircle bgCircle-pink bgBlur-right-top'></div> 
        <div className='bgCircle bgCircle-orange bgBlur-left-top'></div>
        <div className='bgCircle bgCircle-red bgBlur-right-bottom'></div>

      </div>
    </section>

  );
}

export default Hero;
